import axiosClient from "../axiosInstance";

/** Active clubs, for the profile dropdown. Any logged-in user. */
export const getActiveClubs = async () => {
  const response = await axiosClient.get("/clubs");
  return response.data;
};

/** Admin CRUD. Soft-inactive only - there is no delete endpoint. */
export const listClubs = async () => {
  const response = await axiosClient.get("/admin/clubs");
  return response.data;
};

export const createClub = async (name) => {
  const response = await axiosClient.post("/admin/clubs", { name });
  return response.data;
};

export const updateClub = async (id, payload) => {
  const response = await axiosClient.put(`/admin/clubs/${id}`, payload);
  return response.data;
};

/** Pull clubs from the BSA (Knack) API and upsert them locally. */
export const syncClubsFromBsa = async () => {
  const response = await axiosClient.post("/admin/clubs/sync-from-bsa");
  return response.data;
};

const clubsService = {
  getActiveClubs,
  listClubs,
  createClub,
  updateClub,
  syncClubsFromBsa,
};

export default clubsService;
